// extracted by mini-css-extract-plugin
export var actionButton = "_f2-0";
export var fileInput = "_f2-2";
export var paperclip = "_f2-1";